import { parse, format } from "date-fns";

export function toBackendDate(dateStr: string) {
  // Parse the local date/time
  const parsed = parse(dateStr, "dd/MM/yyyy HH:mm", new Date());

  // Format as ISO-like string without timezone
  return format(parsed, "yyyy-MM-dd'T'HH:mm:ss");
}
